
<div class="container mt-3 mx-auto">
  <div>
    <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-id" scope="col">
                ID
              </th>
              <th id="col-cnpjCliente" scope="col">
                CNPJ Cliente
              </th>
              <th id="col-isEsco" scope="col">
                Esco
              </th>
              <th id="col-ideRascunho" scope="col">
                Nome do representante
              </th>
              <th id="col-ideRascunho" scope="col">
                Id. rascunho
              </th>
              <th id="col-token" scope="col" >
                Id. token
              </th>
              <th id="col-dataAprovacao" scope="col" >
                Dt. aprovação
              </th>
              <th id="col-estado" scope="col" >
                Estado
              </th>
              <th id="col-acoes" class="text-center" scope="col">
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let questionario of questionarios">
              <td>{{ questionario.id }}</td>
              <td>{{ questionario.dadosCliente.cnpjCliente | bnMask: 'CNPJ' }}</td>
              <td>{{ questionario.dadosCliente.isEsco == true? 'Sim' : 'Não'}}</td>
              <td>{{ questionario.dadosCliente.nomeRepresentante }}</td>
              <td>{{ questionario.ideRascunho}}</td>
              <td>{{ questionario.token}}</td>
              <td>{{ questionario.dataAprovacao | date: 'dd/MM/yyyy '}}</td>
              <td>{{ questionario.estado?.nomeEstado }}</td>
              <td>
                <a href="javascript:void(0)" (click)="abrirModalExclusaoQuestionario(questionario.id)">
                  <i
                      class="fa fa-trash cursor-pointer ms-4"
                      placement="left-top"
                      ngbTooltip="Excluir questionário">
                  </i>
                </a>
                <a href="javascript:void(0)" (click)="irParaAvaliacaoQuestionario(questionario?.dadosCliente?.cnpjCliente, questionario?.token)">
                  <i
                      class="fa fa-search cursor-pointer ms-4"
                      placement="left-top"
                      ngbTooltip="Visualizar/Avaliar questionário">
                  </i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
<ng-template #body>
  <div class="container">
    <p>Confirma a exclusão do questionário ? Todas as perguntas vinculadas serão apagadas.</p>
  </div>
</ng-template>

<ng-template #botoes>
  <button class="btn btn-danger" (click)="dismiss()">Cancelar</button>
  <button class="btn btn-success" (click)="excluirQuestionario()">Confirmar</button>
</ng-template>
